import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IconsModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ActionSheetItem, NavigationModule } from '@progress/kendo-angular-navigation';

@Component({
  selector: 'casi-action-sheet',
  standalone: true,
  imports: [
        CommonModule,
        LayoutModule,
        ButtonsModule,
        IndicatorsModule,
        RouterModule,
        IconsModule,
        NavigationModule,
  ],
  templateUrl: './action-sheet.component.html',
  styleUrl: './action-sheet.component.scss'
})
export class ActionSheetComponent {
  public opened = true;

  public actionSheetItems: ActionSheetItem[] = [
    { title: "Edit Item" },
    { title: "Add to Favorites" },
    { title: "Upload New" },
    { title: "Cancel" },
  ];

  public clickHandler(): void {
    this.opened = true;
  }

  public onOverlayClick(): void {
    this.opened = false;
  }

  public onItemClick(): void {
    this.opened = false;
  }
}
